module.exports = __webpack_public_path__ + "static/media/workflow1.410c0eba.svg";